import * as React from "react";
import styled, { css } from "styled-components";
import { Col, Row } from "components/bootstrap";
import useUserDateTime from "hooks/useUserDateTime";
import TimeRangeTabs, { timeRangePickerTabs } from "./TimeRangePickerTabs";
import TimeRangePresetRow from "./TimeRangePresetRow";
export const allTimeRangeTypes = Object.keys(timeRangePickerTabs);
const Timezone = styled.p(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
    padding-left: 3px;
    margin: 0;
    min-height: 34px;
    display: flex;
    align-items: center;
  `
);
const TimeRangePickerFormContent = ({ children = void 0, validTypes = allTimeRangeTypes, limitDuration }) => {
  const { userTimezone } = useUserDateTime();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(TimeRangePresetRow, { limitDuration }), /* @__PURE__ */ React.createElement(TimeRangeTabs, { limitDuration, validTypes }))), /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(Timezone, null, "All timezones using: ", /* @__PURE__ */ React.createElement("b", null, userTimezone))), /* @__PURE__ */ React.createElement(Col, { md: 6 }, children)));
};
export default TimeRangePickerFormContent;
